export default [
  {
    name: 'Tippspiel',
    icon: 'ti-home',
    path: '/betgamedata'
  },
  {
    name: 'Design',
    icon: 'ti-paint-roller',
    path: '/betgamedesign'
  },
  {
    name: 'Spielregeln',
    icon: 'ti-list',
    path: '/betgamerules'
  },
  {
    name: 'Nutzungsbedingungen',
    icon: 'ti-align-justify',
    path: '/betgameconditions'
  },
  {
    name: 'Datenschutzerklärung',
    icon: 'ti-info-alt',
    path: '/betgameprivacy'
  },
  {
    name: 'Werbevereinbarung',
    icon: 'ti-info',
    path: '/betgameadconsent'
  },
  {
    name: 'Wertung',
    icon: 'ti-settings',
    path: '/betgamesettings'
  },
  {
    name: 'Slides',
    icon: 'ti-layout-slider',
    path: '/betgameslides'
  },
  {
    name: 'Banner',
    icon: 'ti-image',
    path: '/betgameads'
  },
  {
    name: 'Spieltagssieger',
    icon: 'ti-cup',
    path: '/matchdayrankings'
  },
  {
    name: 'Benutzer',
    icon: 'ti-user',
    path: '/users'
  },
  {
    name: 'Sonderfragen',
    icon: 'ti-help',
    path: '/questions'
  },
  {
    name: 'Statistiken',
    icon: 'ti-stats-up',
    path: '/statistics'
  },
  {
    name: 'Logout',
    icon: 'ti-control-eject',
    path: '/logout'
  }
]



// WEBPACK FOOTER //
// ./src/bgsidebarLinks.js